import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AssetManagementItem, WarehouseOpsSpecialMoveDtoCreate } from 'src/app/api/models';
import { WarehouseService } from 'src/app/api/services';
import {
  SPECIAL_MOVE_OPERATIONS,
  SpecialMoveOperationInfo,
  SpecialOperation,
  specialMoveAsksDestination,
  specialPositionLabel,
} from '../special-move';

// Esegue un'operazione dedicata (guasto, ripristino, RAEE, smarrito, ritrovato) su uno o più asset.
// data: { operation: SpecialOperation; assets: AssetManagementItem[] }
// Si chiude con { done: true } se l'operazione è stata registrata.
@Component({
  selector: 'app-modal-special-move',
  templateUrl: './modal-special-move.component.html',
  styleUrls: ['./modal-special-move.component.scss'],
})
export class ModalSpecialMoveComponent {
  operation: SpecialOperation;
  assets: AssetManagementItem[];
  info: SpecialMoveOperationInfo;
  askDestination: boolean;

  notes = new FormControl<string>('', { nonNullable: true });
  destination = new FormControl<number | null>(null);
  acknowledged = new FormControl<boolean>(false, { nonNullable: true });

  isLoading = false;
  errorMessage?: string;

  readonly positionLabel = specialPositionLabel;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private warehouseService: WarehouseService
  ) {
    this.operation = config.data!.operation;
    this.assets = config.data!.assets;
    this.info = SPECIAL_MOVE_OPERATIONS[this.operation];
    this.askDestination = specialMoveAsksDestination(this.operation, this.assets);
  }

  get canSubmit(): boolean {
    if (this.isLoading || this.assets.length === 0) return false;
    return this.info.irreversible ? this.acknowledged.value : true;
  }

  close() {
    this.ref.close();
  }

  submit() {
    if (!this.canSubmit) return;
    this.isLoading = true;
    this.errorMessage = undefined;
    const notes = this.notes.value.trim();
    this.warehouseService
      .warehouseControllerCreateSpecialMove({
        body: {
          operation: this.operation as WarehouseOpsSpecialMoveDtoCreate['operation'],
          asset_ids: this.assets.map(a => a.id),
          ...(notes && { notes }),
          ...(this.askDestination && this.destination.value
            ? { to_registry_office_id: this.destination.value }
            : {}),
        },
      })
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.ref.close({ done: true, operation: this.operation, count: this.assets.length });
        },
        error: err => {
          this.isLoading = false;
          this.errorMessage =
            (typeof err?.error?.message === 'string' && err.error.message) ||
            err?.error?.message?.message ||
            'Operazione non riuscita.';
        },
      });
  }
}
